// extracted by mini-css-extract-plugin
export default {"table":"OfferTable_table__8vhI1"};